var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1957 3.51393C17.6792 -1.17131 10.3675 -1.17131 5.85678 3.51393L5.26158 4.13285C5.034 4.36804 5.034 4.74558 5.26158 4.98077L7.12305 6.9118C7.23392 7.0294 7.42065 7.0294 7.53152 6.9118L8.33096 6.08245C11.4762 2.81454 16.5821 2.81454 19.7274 6.08245L20.4743 6.8561C20.5852 6.9737 20.7719 6.9737 20.8828 6.8561L22.7384 4.92507C22.966 4.68988 22.966 4.31233 22.7384 4.07714L22.1957 3.51393ZM27.8273 8.80575L26.1561 7.16779C25.9258 6.94309 25.5537 6.94309 25.3293 7.17371L19.9732 12.4246C19.9142 12.4779 19.8256 12.4779 19.7665 12.4246L14.4104 7.17371C14.1801 6.94901 13.814 6.94901 13.5837 7.17371L8.23347 12.4246C8.17442 12.4779 8.08584 12.4779 8.02678 12.4246L2.67067 7.17371C2.44037 6.94901 2.07424 6.94901 1.84393 7.17371L0.17273 8.81167C-0.0575767 9.03637 -0.0575767 9.39708 0.17273 9.62178L7.71971 17.0133C7.95002 17.238 8.31614 17.238 8.54645 17.0133L13.8967 11.7624C13.9557 11.7091 14.0443 11.7091 14.1033 11.7624L19.4595 17.0133C19.6898 17.238 20.0559 17.238 20.2862 17.0133L27.8273 9.61586C28.0576 9.39116 28.0576 9.03046 27.8273 8.80575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.0ee4fc1ae9e126d0b3e79fe8e49f68d2.svg";
export { ForwardRef as ReactComponent };